import { formatCurrency, useAppContext } from "application";
import { PaymentMethodData } from "../PaymentMethods/PaymentMethods.types";
import { InstallmentProps } from "../PaymentMethods/subcomponents/Installment/installment.types";

interface ViewMoreHookProps {
  maxNumberInstallments: number;
  salePrice: number;
  spotPrice?: number;
  discountPercentage: string;
}

export const useViewPaymentMethods = ({
  discountPercentage,
  maxNumberInstallments,
  salePrice,
  spotPrice,
}: ViewMoreHookProps) => {
  const installmentsList: string[] = [];
  const newInstallmentList = new Set<InstallmentProps>();
  const {
    isClientMobile,
    isViewMorePaymentMethodsOpen,
    setIsViewMorePaymentMethodsOpen,
  } = useAppContext();

  for (let i = 0; i < maxNumberInstallments; i += 1) {
    const installmentIndex = i + 1;
    const isInstallmentWithDiscount =
      discountPercentage && spotPrice && installmentIndex === 1;
    const installmentPrice = salePrice / installmentIndex;

    newInstallmentList.add({
      hasFees: false,
      price: isInstallmentWithDiscount ? spotPrice : installmentPrice,
      totalPrice: isInstallmentWithDiscount ? spotPrice : salePrice,
      quantity: installmentIndex,
    });
    installmentsList.push(
      `${installmentIndex}x ${formatCurrency(installmentPrice)} ${
        !i && +discountPercentage
          ? `(${discountPercentage}% de desconto)`
          : `sem juros`
      }`
    );
  }

  const paymentMethodsData: PaymentMethodData = {
    discount: Number(discountPercentage),
    price: salePrice,
    priceWithDiscount: spotPrice,
    installments: Array.from(newInstallmentList),
  };

  return {
    installmentsList,
    paymentMethodsData,
    isViewMoreModalOpen: isViewMorePaymentMethodsOpen && !isClientMobile,
    isViewMoreComponentOpen: isViewMorePaymentMethodsOpen && isClientMobile,
    setIsViewMorePaymentMethodsOpen,
    isClientMobile,
  };
};
